export function cityToUrl(city: string): string {
  if (!city) return "";

  return city
    .toLowerCase()
    .normalize("NFD") // remove acentos
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\//g, " ") // troca barras por espaço
    .replace(/[^a-z0-9 ]/g, "") // remove caracteres especiais
    .trim();
    //.replace(/\s+/g, "-"); // troca espaços por hífens
}

export function formatAmount(amount: number, isFractioned: boolean): string {
  if (isNaN(amount)) return "0"

  return amount.toLocaleString("pt-BR", {
    minimumFractionDigits: isFractioned ? 3 : 0,
    maximumFractionDigits: isFractioned ? 3 : 0,
  })
}
